var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"ml-1 mb-4"},[_c('v-icon',{staticClass:"text-small primary--text",attrs:{"size":"24"}},[_vm._v(_vm._s(_vm.icon))]),_c('h3',{staticClass:"ml-2 text-small primary--text"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }